<template>
  <div class="w-full">
    <slot v-if="state === 'loading'" name="loading">
      <AtomIconAppLoader class="w-12 h-12" />
    </slot>
    <slot v-if="state === 'error'" name="error" />
    <slot v-if="state === 'ready'" v-bind="data" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useAnimalStore } from '~/store/animal'
import { useShelterStore } from '~/store/shelter'

interface Props {
  animalId?: number | string
}

const { animalId = '' } = defineProps<Props>()

const emit = defineEmits(['error'])

const state = ref<string>('loading')
const data = ref<{ animal: any; shelter: any } | null>(null)

const animalStore = useAnimalStore()
const shelterStore = useShelterStore()

onMounted(async () => {
  try {
    const animal = await animalStore.fetch(animalId)
    const shelter = animal.site.handle === 'vermisteDieren' ? {} : await shelterStore.fetch({ site: animal.site.handle })
    state.value = animal && shelter ? 'ready' : 'error'
    data.value = { animal, shelter }
  } catch (error) {
    emit('error', { animalId: animalId, error })
    state.value = 'error'
  }
})
</script>
